import { render, staticRenderFns } from "./UsersDialog.vue?vue&type=template&id=b55f61e4&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./UsersDialog.vue?vue&type=script&lang=js"
export * from "./UsersDialog.vue?vue&type=script&lang=js"
import style0 from "./UsersDialog.vue?vue&type=style&index=0&id=b55f61e4&prod&lang=scss&scoped=true"
import style1 from "./UsersDialog.vue?vue&type=style&index=1&id=b55f61e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55f61e4",
  null
  
)

export default component.exports